import React from "react";
import PropTypes from "prop-types";

export default class ContactTypePopoverMenuMore extends React.Component<any> {

    static propTypes = {
        parent: PropTypes.object,
        field: PropTypes.object
    }

    onClick = () => {
        this.props.parent.hidePopover()
        gd.goTo(gd.modules.crmContact.settingsUrl)
    }

    render() {
        return (
            <div className="help">
                <div className="ui5-link-small" onClick={this.onClick}>
                    Edit options
                </div>
            </div>
        );
    }
}